import React from 'react';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import {Calendar, momentLocalizer} from 'react-big-calendar';
import moment from 'moment';
import myEventsList from '../EventsList';
require('react-big-calendar/lib/css/react-big-calendar.css');


const localizer = momentLocalizer(moment);

const EventsCalendar = () => (
  <div>
    <Calendar
      localizer={localizer}
      events={myEventsList}
      startAccessor="start"
      endAccessor="end"
      style={{height: 500}}
    />
  </div>
);

/**
 * This function renders the Events page
 * @component EventsPage
 * @return {Component} EventsPage component
 */
export default function EventsPage() {
  return (
    <Card style={{
      padding: '100px',
      width: '1200px',
      margin: '30px auto',
    }}>
      <Grid item xs={12} md={8} style={{margin: '0 auto'}}>
        <Typography variant="h6" gutterBottom>
          <h1 style={{textAlign: 'center'}}>Events Calendar</h1>
          <br />
        </Typography>
        <Divider />
        <EventsCalendar />
      </Grid>
    </Card>
  );
}
